import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import './UserProfile.css'; // Import the CSS file
interface UserProfileProps {
    userId: string | null;
}

const UserProfile: React.FC<UserProfileProps> = ({ userId }) => {
    const [dob, setDob] = useState<string | null>(null);
    const [location, setLocation] = useState<string | null>(null);
    const [timeOfBirth, setTimeOfBirth] = useState<string | null>(null);
    const [latitude, setLatitude] = useState<number | null>(null);
    const [longitude, setLongitude] = useState<number | null>(null);
    const [gender, setGender] = useState<string | null>(null);
    const [sex, setSex] = useState<string | null>(null);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
    const [saveNeeded, setSaveNeeded] = useState(false);
    const [numMessages, setNumMessages] = useState<number | null>(null); // New state for number of messages


    const handleInputChange = (setter: React.Dispatch<React.SetStateAction<any>>) => {
        return (e: React.ChangeEvent<HTMLInputElement>) => {
            setter(e.target.value);
            setSaveNeeded(true);
        };
    };

    const saveProfile = async () => {
        try {
            await axios.put(`${config.apiUrl}/user/${userId}`, {
                dob,
                location,
                timeOfBirth,
                latitude,
                longitude,
                gender,
                sex
            });
            setSaveNeeded(false);
        } catch (error) {
            console.error('Failed to save user profile:', error);
        }
    };

    useEffect(() => {



        const fetchProfile = async () => {
            try {
                const response = await axios.get(`${config.apiUrl}/user/${userId}`);
                const data = response.data;
                setDob(data.dob);
                setLocation(data.location);
                setTimeOfBirth(data.timeOfBirth);
                setLatitude(data.latitude);
                setLongitude(data.longitude);
                setGender(data.gender);
                setSex(data.sex);
                setNumMessages(data.messages);
            } catch (error: any) {
                if (axios.isAxiosError(error)) {
                    if (error.response?.status === 404) {
                        await axios.post(`${config.apiUrl}/user`, {
                            userId,
                            dob: "",
                            location: "",
                            timeOfBirth: "",
                            latitude: 0,
                            longitude: 0,
                            gender: "",
                            sex: ""
                        });
                    } else {
                        console.error('Failed to fetch user profile:', error);
                    }
                }
            }
            setInitialFetchDone(true);
        };
        fetchProfile();
    }, [userId]);


    return (
        <div className="userProfile">
            <h3>User Profile</h3>
            {initialFetchDone ? (
                <div>
                    <div>
                        <label>Date of Birth:</label>
                        <input type="date" required value={dob || ''} onChange={handleInputChange(setDob)} />
                    </div>
                    <div>
                        <label>Location:</label>
                        <input type="text" value={location || ''} onChange={handleInputChange(setLocation)} />
                    </div>
                    <div>
                        <label>Time of Birth:</label>
                        <input type="time" value={timeOfBirth || ''} onChange={handleInputChange(setTimeOfBirth)} />
                    </div>

                    <div>
                        <label>Gender:</label>
                        <input type="text" value={gender || ''} onChange={handleInputChange(setGender)} />
                    </div>
                    <div>
                        <label>Sex:</label>
                        <input type="text" value={sex || ''} onChange={handleInputChange(setSex)} />
                    </div>
                    <div>
                        <label>Latitude:</label> <p>(optional)</p>
                        <input type="number" value={latitude?.toString() || ''} onChange={handleInputChange((value: string) => setLatitude(Number(value)))} />
                    </div>
                    <div>
                        <label>Longitude:</label><p>(optional)</p>
                        <input type="number" value={longitude?.toString() || ''} onChange={handleInputChange((value: string) => setLongitude(Number(value)))} />
                    </div>
                    <div>
                        <label>Number of Messages:</label>
                        <input type="text" value={numMessages?.toString() || '0'} readOnly />
                    </div>
                    {saveNeeded && <button onClick={saveProfile}>Save</button>}
                </div>
            ) : (
                <div>Loading...</div>
            )}
        </div>
    );
};

export default UserProfile;
